import {
    REQUEST_BILLING_MONTHLY_BALANCE,
    RECEIVE_BILLING_MONTHLY_BALANCE,
    ERROR_BILLING_MONTHLY_BALANCE
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"


export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_BILLING_MONTHLY_BALANCE:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_BILLING_MONTHLY_BALANCE:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                validUntil: loadDataRefresh.default + Date.now(),
                message: '',
            }
        case ERROR_BILLING_MONTHLY_BALANCE:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}